module.exports = __webpack_public_path__ + "static/tomato-fb34bd2bc2c897e7b651e79e1276d030.png";